package com.narbase.letsgo.web.views.support

import com.narbase.kunafa.core.components.*
import com.narbase.kunafa.core.components.layout.LinearLayout
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.dependent.matchParent
import com.narbase.kunafa.core.dimensions.dependent.wrapContent
import com.narbase.kunafa.core.dimensions.dimen
import com.narbase.kunafa.core.dimensions.px
import com.narbase.kunafa.core.drawable.Color
import com.narbase.kunafa.core.lifecycle.LifecycleOwner
import com.narbase.letsgo.dto.KmmLong
import com.narbase.letsgo.web.common.AppColors
import com.narbase.letsgo.web.translations.localized
import com.narbase.letsgo.web.utils.horizontalFiller
import com.narbase.letsgo.web.utils.scrollable.scrollable
import com.narbase.letsgo.web.utils.table.headerCell
import com.narbase.letsgo.web.utils.table.listTable
import com.narbase.letsgo.web.utils.table.tableCell
import com.narbase.letsgo.web.utils.table.tableRow
import com.narbase.letsgo.web.utils.verticalSeparator
import com.narbase.letsgo.web.utils.views.matchParentDimensions
import com.narbase.letsgo.web.utils.views.pointerCursor
import com.narbase.letsgo.web.utils.views.withLoadingAndError


class SupportIssuesManagementComponent(
    val categoryId: KmmLong
) : Component() {
    val viewModel = SupportIssuesManagementViewModel(categoryId)

    private var listTableBody: View? = null

    override fun onViewMounted(lifecycleOwner: LifecycleOwner) {
        super.onViewMounted(lifecycleOwner)
        viewModel.getSupportIssues()
    }

    private fun onListLoaded() {
        listTableBody?.clearAllChildren()
        listTableBody?.apply {
            viewModel.supportIssuesList.forEachIndexed { index, item ->
                tableRow {
                    style {
                        alignItems = Alignment.Center
                        paddingEnd = 8.px
                    }
                    tableCell(item.title.en, 1, 14.px)
                    tableCell(item.body.en ?: "", 1, 14.px)
                    tableCell(if (item.isActive) "isActive" else "", 1, 14.px)
                    onClick = {
                        UpsertSupportIssueDialog(
                            categoryId = categoryId,
                            supportIssue = item
                        ) {
                            viewModel.getSupportIssues()
                        }.show()
                    }
                }

                if (index != viewModel.supportIssuesList.lastIndex) {
                    verticalSeparator()
                }
            }
        }
    }

    override fun View?.getView() = view {
        id = "ManagementRootView"
        style {
            matchParentDimensions
        }
        scrollable {
            style {
                matchParentDimensions
            }

            verticalLayout {
                style {
                    width = matchParent
                    height = wrapContent
                    padding = 32.px
                }

                horizontalLayout {
                    style {
                        width = matchParent
                    }
                    textView {
                        text = "Issues Management".localized()
                        style {
                            width = wrapContent
                            fontSize = 20.px
                            fontWeight = "bold"
                        }
                    }

                    horizontalFiller()

                    addButton()

                }

                verticalLayout {
                    matchParentDimensions()
                    withLoadingAndError(viewModel.getUiState,
                        onRetryClicked = { viewModel.getSupportIssues() },
                        onLoaded = { onListLoaded() })

                    listTableBody = listTable {
                        headerCell("Title".localized(), 1)
                        headerCell("Body".localized(), 1)
                        headerCell("".localized(), { 24.px })
                    }
                }
            }
        }
    }

    private fun LinearLayout.addButton() {
        textView {
            style {
                color = Color.white
                padding = "2px 12px".dimen()
                backgroundColor = AppColors.mainColor
                borderRadius = 12.px
                pointerCursor()
                hover {
                    backgroundColor = AppColors.mainDarkColor
                }
            }

            onClick = {
                UpsertSupportIssueDialog(
                    categoryId = categoryId,
                    supportIssue = null
                ) {
                    viewModel.getSupportIssues()
                }.show()
            }

            id = "AddButton"
            text = "+ Add New Issue".localized()
        }
    }
}
